<template>
    <div>
        <div class="diagram" :id=id>
        </div>
    </div>
</template>

<script>
    import ArcDiagramSpec from '../vega-spec/parallel-arc-diagram.v.json'
    import embed from 'vega-embed'
    import _ from 'lodash'

    function indexByName(arr, name) {
        return arr.findIndex(elt => elt.name === name);
    }


    export default {
        name: "ParallelArcDiagram",
        props: ["data", "id", "metrics"],
        data() {
            return {
                spec: {}
            }
        },
        watch: {
            spec(v) {
                if (v) this.draw()
            },
            data(v) {
                if (v) {
                    this.load(v)
                    this.draw()
                }
            }
        },
        mounted: function () {
            this.spec = JSON.parse(JSON.stringify(ArcDiagramSpec))
            this.load(this.data)
        },
        methods: {
            annotateEdges(template, candidate, pairing) {
                if (template.length === 0 && candidate.length === 0) return {template: template, candidate: candidate}
                const te = new Set(template.map(e => e.eType + "," + e.Source + "," + e.Target))
                const ce = new Set(candidate.map(e => e.eType + "," + e.Source + "," + e.Target))
                // Boring piping to preparing pairing dict and inverted pairing dict in ok format...
                const pairingDict = _.keyBy(pairing.map(e => ({
                    "templateID": e.templateID,
                    "candidateID": e.candidateID
                })), 'candidateID')
                Object.keys(pairingDict).map(key => pairingDict[key] = pairingDict[key]["templateID"])
                const invertedPairingDict = _.invert(pairingDict)
                // End of boring nonsense

                const exists = (e, p, oe) => (
                    p[e.Source.toString()] &&
                    p[e.Target.toString()] &&
                    oe.has(e.eType + "," + p[e.Source.toString()] + "," + p[e.Target.toString()])
                )
                return {
                    "template": template.map(e => ({"Status": exists(e, invertedPairingDict, ce) ? "common" : "missing", ...e})),
                    "candidate": candidate.map(e => ({"Status": exists(e, pairingDict, te) ? "common" : "supplementary", ...e}))
                }
            },
            async draw() {
                await embed('#' + this.id, this.spec, {actions: false})
                    .catch((err) => console.error(err))
            },
            load(v) {
                if (!v) return;
                let annotatedEdges = this.annotateEdges(v.template.edges, v.candidate.edges, v.pairing)

                // Update metric tracks
                let metrics = this.spec["data"][indexByName(this.spec["data"], "metrics")]
                metrics["values"] = this.metrics.map(m => ({"value": m}))
                let trackMatrix = this.spec["data"][indexByName(this.spec["data"], "track-matrix")]
                trackMatrix["transform"][0]["fields"] = this.metrics

                // Wire data
                // Only showing edges out of the focus node would be better
                let templateEdges = this.spec["data"][indexByName(this.spec["data"], "template-edges")]
                templateEdges["values"] = _.cloneDeep(annotatedEdges.template)
                let templateNodes = this.spec["data"][indexByName(this.spec["data"], "template-nodes")]
                templateNodes["values"] = _.cloneDeep(v.template.nodes)
                let candidateEdges = this.spec["data"][indexByName(this.spec["data"], "candidate-edges")]
                candidateEdges["values"] = _.cloneDeep(annotatedEdges.candidate)
                let candidateNodes = this.spec["data"][indexByName(this.spec["data"], "candidate-nodes")]
                candidateNodes["values"] = _.cloneDeep(v.candidate.nodes)
                let pairing = this.spec["data"][indexByName(this.spec["data"], "pairing")]
                pairing["values"] = _.cloneDeep(v.pairing)
            }
        }
    }
</script>

<style scoped>
</style>



